var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.81324 17 0 13.1859 0 8.49803C0 6.40305 0.768241 4.39003 2.16358 2.83015L2.56003 2.3872H0.486936V0.97015H5.31221V5.79655H3.89582V3.08881L3.43981 3.55612C2.13495 4.8932 1.41639 6.64822 1.41639 8.49803C1.41639 12.405 4.59398 15.5833 8.5 15.5833C12.406 15.5833 15.5836 12.405 15.5836 8.49803C15.5836 6.63177 14.8614 4.86918 13.5503 3.53473C12.2738 2.23516 10.5764 1.48484 8.76551 1.41771V0C10.9531 0.0674629 13.0055 0.965214 14.5499 2.53167C16.1298 4.13433 17 6.25299 17 8.49803C17 13.1862 13.1868 17 8.5 17Z",
    fill: "#45657B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.2ddc82dc6ba470f9c694c07d7083ae81.svg";
export { ForwardRef as ReactComponent };